import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Testbed} from "../../../model/testbed";
import {Contract} from "../../../model/contract";

@Component({
  selector: 'aw-add-testers-dialog',
  templateUrl: './add-testers-dialog.component.html',
  styleUrls: ['./add-testers-dialog.component.scss']
})
export class AddTestersDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {testbed: Testbed, contract: Contract},
    public dialogRef: MatDialogRef<AddTestersDialogComponent>,
  ) {


  }

  ngOnInit(): void {
  }

}
